export const APP_ACTION_TYPES = {
  SET_IS_SIDEBAR_OPEN: 'app/SET_IS_SIDEBAR_OPEN'
};
